export default __webpack_public_path__ + "static/media/banner1.bd5f7fd8.jpg";